/**
 * Constants for Cover Club
 */

export const REACTIONS = [
  { key: 'stunning', emoji: '✨', label: 'Stunning' },
  { key: 'caught_eye', emoji: '👀', label: 'Caught my eye' },
  { key: 'beautiful_design', emoji: '🎨', label: 'Beautiful design' },
  { key: 'fits_story', emoji: '📖', label: 'Fits the story' },
  { key: 'instant_tbr', emoji: '💫', label: 'Instant TBR' },
];

export const STYLES = ['Minimalist', 'Dark Academia', 'Pastel', 'Illustrated', 'Typographic', 'Photographic'];
export const ERAS = ['Contemporary', 'Y2K', 'Modern Classic', 'Vintage'];

export const COLLECTION_DEFS = [
  { key: 'most_loved', title: 'Most Loved Covers', tone: 'coral', curator: 'ScribbleReads Editors' },
  { key: 'cover_crushes', title: 'Cover Crushes', tone: 'coral', curator: 'Community picks' },
  { key: 'best_fantasy', title: 'Best Fantasy Covers', tone: 'sage', curator: 'ScribbleReads Editors' },
  { key: 'minimalist', title: 'Minimalist Covers', tone: 'blue', curator: 'ScribbleReads Editors' },
  { key: 'dark_academia', title: 'Dark Academia Covers', tone: 'blue', curator: 'Community picks' },
  { key: 'pastel', title: 'Pastel Covers', tone: 'yellow', curator: 'ScribbleReads Editors' },
  { key: 'eye_catching', title: 'Most Eye-Catching Covers', tone: 'coral', curator: 'Community picks' },
  { key: 'instant_tbr_collection', title: 'Covers That Made Me Add It to TBR', tone: 'sage', curator: 'Community picks' },
];

export const CLUB_TABS = [
  { key: 'feed', label: 'Discover' },
  { key: 'battles', label: 'Cover Battles' },
  { key: 'collections', label: 'Collections' },
];

export const EMPTY_STATE_MESSAGES = {
  noResults: {
    heading: 'No covers match yet.',
    subheading: 'Try a different genre, mood, or style filter.',
    cta: 'Clear Filters',
  },
  noComments: {
    heading: 'No comments yet.',
    subheading: 'Be the first to say what caught your eye.',
    cta: null,
  },
  noCollectionCovers: {
    heading: 'Nothing added here yet.',
    subheading: 'Save covers into this collection as you find them.',
    cta: null,
  },
};

export const PAGE_SIZE = 8;
